import { CurrencyDollarIcon } from '@phosphor-icons/react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { NumericInputFormField } from '@/components/form/numeric-input-form-field'
import { SwitchFormField } from '@/components/form/switch-form-field'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'

import * as S from './service-fee-modal.styled'
import { getHoursLabel } from './service-fee-modal.utils'

interface ServiceFeeRowProps {
  index: number
  duration: number
  isLoading: boolean
  showSwitchAndTooltip: boolean
}

export const ServiceFeeRow = ({
  index,
  duration,
  isLoading,
  showSwitchAndTooltip,
}: ServiceFeeRowProps) => {
  const { t } = useTranslation(['parking-management'])
  const enabled = useWatch({ name: `pricing.${index}.enabled` }) as boolean

  return (
    <tr>
      <Typography as="td" size="text-medium" weight="medium">
        {getHoursLabel(duration, t)}
      </Typography>
      <S.SwitchCell>
        <S.SwitchContainer>
          <NumericInputFormField
            icon={CurrencyDollarIcon}
            disabled={!enabled || isLoading}
            name={`pricing.${index}.price`}
            size="small"
            min={0}
            mode="decimal"
            decimalPlaces={2}
          />
        </S.SwitchContainer>
        {showSwitchAndTooltip && (
          <>
            <SwitchFormField
              disabled={isLoading}
              name={`pricing.${index}.enabled`}
              inlineLabel={
                enabled
                  ? t('parking-management:serviceFeeRow.on')
                  : t('parking-management:serviceFeeRow.off')
              }
              size="medium"
            />
            <Tooltip>{t('parking-management:serviceFeeRow.tooltip')}</Tooltip>
          </>
        )}
      </S.SwitchCell>
    </tr>
  )
}
